import {Injectable} from '@angular/core';
import {OfflinePeerConnectionApiService} from '../../../../services/api/network/offline/peer-connection/offline-peer-connection-api.service';
import {OfflineConnectionApiService} from '../../../../services/api/network/offline/connection/offline-connection-api.service';
import {OfflineNodeApiService} from '../../../../services/api/network/offline/node/offline-node-api.service';
import {OfflineMapSummaryStatisticsService} from '../offline-map-summary-statistics/offline-map-summary-statistics.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineMapSummaryApiService {

  constructor(private offlineNodeApiService: OfflineNodeApiService,
              private offlineConnectionApiService: OfflineConnectionApiService,
              private offlinePconApiService: OfflinePeerConnectionApiService,
              private offlineMapSummaryStatistics: OfflineMapSummaryStatisticsService) {
  }

  getNodesTotal(success) {
    this.offlineNodeApiService.getNodesForMap().then(fetchedNodes => {
      const nodesTotal = [{field: 'NODES', value: fetchedNodes.length, labelStyle: 'total'}];
      success(nodesTotal);
    });
  }

  getNodesDistribution(success) {
    this.offlineNodeApiService.getNodesForMap().then(fetchedNodes => {
      const statusObject = this.offlineMapSummaryStatistics.calculateNodesStatusDistribution(fetchedNodes);
      const nodesDistribution =
        [
          {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
          {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'},
          {title: 'LOCKED', status: statusObject.locked, image: 'assets/images/network/state/warning_medium.png', cssTitleClass: 'warning'}
        ];
      success(nodesDistribution);
    });
  }


  getPeerConnectionsTotal(success) {
    this.offlinePconApiService.getPConsForMap().then(fetchedPeerConnections => {
      const pConsCount = Array.isArray(fetchedPeerConnections) ? fetchedPeerConnections.length : fetchedPeerConnections.elements.length;
      const peerConnectionsTotal =
        [
          {field: 'PEER CONNECTIONS', value: pConsCount, labelStyle: 'total'}
        ];
      success(peerConnectionsTotal);
    });
  }


  getPeerConnectionsDistribution(success) {
    this.offlinePconApiService.getPConsForMap().then(fetchedPeerConnections => {
      const pCons = Array.isArray(fetchedPeerConnections) ? fetchedPeerConnections : fetchedPeerConnections.elements;
      const statusObject = this.offlineMapSummaryStatistics.calculatePeerConnectionsStatusDistribution(pCons);
      const peerConnectionsDistribution =
        [
          {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
          {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'},
          {title: 'LOCKED', status: statusObject.locked, image: 'assets/images/network/state/warning_medium.png', cssTitleClass: 'warning'}
        ];
      success(peerConnectionsDistribution);
    });
  }

  getConnectionsTotal(success) {
    this.offlineConnectionApiService.getConnectionsForMap().then(fetchedConnections => {
      const connectionsCount = Array.isArray(fetchedConnections) ? fetchedConnections.length : fetchedConnections.elements.length;
      const connectionsTotal =
        [
          {field: 'CONNECTIONS', value: connectionsCount, labelStyle: 'total'}
        ];
      success(connectionsTotal);
    });
  }

  getConnectionsDistribution(success) {
    this.offlineConnectionApiService.getConnectionsForMap().then(fetchedConnections => {
      const connections = Array.isArray(fetchedConnections) ? fetchedConnections : fetchedConnections.elements;
      const statusObject = this.offlineMapSummaryStatistics.calculateConnectionsStatusDistribution(connections);
      const connectionsDistribution =
        [
          {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
          {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'}
        ];
      success(connectionsDistribution);
    });
  }
}
